// Components==============
import Button from 'components/UI/Button/Button';
import DotsMenu from 'components/UI/DotsMenu/DotsMenu';
import { AnimatePresence } from 'framer-motion';
import { useMediaQ } from 'hooks/useMediaQ';
import { usePermission } from 'hooks/usePermission';
import { useTranslate } from 'hooks/useTranslate';
import { ProjectDetailsContext } from 'pages/Workspace/ProjectDetails/ProjectDetails';
import React, { useContext, useState } from 'react';
import { useHistory } from 'react-router';
import DeleteModal from './components/DeleteModal/DeleteModal';
import PublishModal from './components/PublishModal/PublishModal';
import SettingsModal from './components/SettingsModal/SettingsModal';
import ShareModal from './components/ShareModal/ShareModal';
import ExportModal from './components/ExportModal/ExportModal';
import './TopRight.module.scss';
// =========================

export default function TopRight() {
  const {
    theme,
    handleProjectAndThemeDuplication,
    deleteCondition,
    rootProject,
    project,
    userId,
  } = useContext(ProjectDetailsContext);
  const userMembership = (rootProject || project)?.members.find(
    (m) => m.user_id === userId
  )?.membership;

  const translate = useTranslate();

  const query = useMediaQ('min', 1024);
  const history = useHistory();

  const isTeacher = usePermission(['Docent', 'super-admin']);

  const editThemeCondition = !theme?.public && theme?.created_by === userId;

  const RequestEditCondition = theme?.public && theme.created_by === userId;

  const publishCondition =
    userMembership === 'owner' &&
    theme?.created_by === userId &&
    !theme?.public;

  const settingsCondition =
    userMembership === 'owner' &&
    theme?.public &&
    (theme?.created_by === userId || rootProject?.process?.length);

  const duplicateCondition = userMembership !== 'teacher';

  // prevent teacher from sharing if project is already copied
  const shareCondition = isTeacher && userMembership !== 'teacher';

  const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false);
  const [publishModalIsOpen, setPublishModalIsOpen] = useState(false);
  const [settingsModalIsOpen, setSettingsModalIsOpen] = useState(false);
  const [shareModalIsOpen, setShareModalIsOpen] = useState(false);
  const [exportModalIsOpen, setExportModalIsOpen] = useState(false);

  const handleEditTheme = () =>
    history.push(`/werkplaats/thema-bouwer/${theme?.id}`);

  const handleDelete = () => setDeleteModalIsOpen(true);
  const handlePublish = () => setPublishModalIsOpen(true);
  const handleSettings = () => setSettingsModalIsOpen(true);
  const handleShare = () => setShareModalIsOpen(true);

  const handleExport = () => setExportModalIsOpen(true);

  const deleteText = deleteCondition
    ? translate('project.actions.delete-project')
    : translate('project.actions.leave-project');

  return (
    <>
      <div styleName="wrapper">
        {query ? (
          <>
            {!!shareCondition && (
              <Button color="grey" onClick={handleShare}>
                {translate('project.actions.project-share')}
              </Button>
            )}
            <DotsMenu>
              {!!editThemeCondition && (
                <button type="button" onClick={handleEditTheme}>
                  {translate('project.actions.edit-theme')}
                </button>
              )}
              {!!publishCondition && (
                <button type="button" onClick={handlePublish}>
                  {translate('general.terms.publish')}
                </button>
              )}
              {!!settingsCondition && (
                <button type="button" onClick={handleSettings}>
                  {translate('course.publish-settings.title')}
                </button>
              )}
              {!!duplicateCondition && (
                <button
                  type="button"
                  onClick={handleProjectAndThemeDuplication}
                >
                  {translate('project.actions.duplicate-project')}
                </button>
              )}
              {!!RequestEditCondition && (
                <a href="mailto:groow@studiotast.com">
                  <button type="button" styleName="mail">
                    {translate('project.actions.edit-theme-2')}
                  </button>
                </a>
              )}

              <button type="button" onClick={handleExport}>
                {translate('project.export-process.export-process')}
              </button>

              <button type="button" styleName="delete" onClick={handleDelete}>
                {deleteText}
              </button>
            </DotsMenu>
          </>
        ) : (
          <DotsMenu>
            {!!publishCondition && (
              <button type="button" onClick={handlePublish}>
                {translate('general.terms.publish')}
              </button>
            )}
            {!!settingsCondition && (
              <button type="button" onClick={handleSettings}>
                {translate('course.publish-settings.title')}
              </button>
            )}
            {!!duplicateCondition && (
              <button type="button" onClick={handleProjectAndThemeDuplication}>
                {translate('project.actions.duplicate-project')}
              </button>
            )}
            {!!shareCondition && (
              <button type="button" onClick={handleShare}>
                {translate('project.actions.project-share')}
              </button>
            )}
            <button type="button" styleName="delete" onClick={handleDelete}>
              {deleteText}
            </button>
          </DotsMenu>
        )}
      </div>
      <AnimatePresence>
        {settingsModalIsOpen && (
          <SettingsModal setModalIsOpen={setSettingsModalIsOpen} />
        )}
        {publishModalIsOpen && (
          <PublishModal setModalIsOpen={setPublishModalIsOpen} />
        )}
        {deleteModalIsOpen && (
          <DeleteModal setModalIsOpen={setDeleteModalIsOpen} />
        )}
        {shareModalIsOpen && (
          <ShareModal setModalIsOpen={setShareModalIsOpen} />
        )}
        {exportModalIsOpen && (
          <ExportModal setModalIsOpen={setExportModalIsOpen} />
        )}
      </AnimatePresence>
    </>
  );
}
